<!-- Loading state -->
@if (loading) {
  <div class="loading-container">
    <div class="loading-content">
      <div class="loading-spinner"></div>
      <div class="loading-message">{{ loadingMessage }}</div>
    </div>
  </div>
}

<!-- Error state -->
@if (errorMessage && !loading) {
  <div class="error-container">
    <div class="error-content">
      <div class="error-icon">⚠️</div>
      <div class="error-message">{{ errorMessage }}</div>
      <div class="error-info">This window will close automatically in a few seconds.</div>
    </div>
  </div>
}

@if (!loading && !errorMessage && this.ProformaInvoice) {
  <div style="position: relative;">
    @if (ActiveDocumentVersion) {
      <div
        style="position: absolute; right: 5px; top: 5px; font-size: 10px; text-align: right; line-height: 1.2;">
        <span>{{ActiveDocumentVersion.FormatNo}}, Rev No. {{ActiveDocumentVersion.VersionNo}}</span>
      </div>
    }
    <table class="companytable">
      <tr>
        <td>
          <div class="company">
            <img src="/assets/img/printlogo.jpeg" />
            <b class="title">{{ Company.CompanyName }}</b>
            <p [innerHTML]="Company.Address"></p>
            <p>Contact: {{ Company.Contact }}</p>
            <p>Email: {{ Company.Email }}</p>
            <p>GSTIN: {{ Company.GST }}</p>
          </div>
          @if (ProformaInvoice) {
            <div class="vendor">
              <b class="title">Consignee</b>
              <p class="name">{{ ProformaInvoice.Customer.CustomerName }}</p>
              <p>{{ ProformaInvoice.Customer.Address }}</p>
              <p>Contact:{{ ProformaInvoice.Customer.CustomerContactNumber }}</p>
              <p>Email:{{ ProformaInvoice.Customer.Email }}</p>
              <p>GSTIN:{{ ProformaInvoice.Customer.Gstnumber }}</p>
              <hr />
              <p>Material Type: {{ProformaInvoice.MaterialType}}</p>
              <p>HSN/SAC Code: {{ProformaInvoice.Hsncode}}</p>
              <p>Port of Loading: {{ProformaInvoice.PortOfLoading}}</p>
              <p>Final Destination: {{ProformaInvoice.FinalDestination}}</p>
              <p>Port of Discharge :{{ProformaInvoice.PortOfDischarge}}</p>
              <p>Mode of Transport :{{ProformaInvoice.ModeOfTransport}}</p>
              <hr />
            </div>
          }
        </td>
        <td>
          <div class="po" style="margin-top:0">
            <div class="title">PROFORMA INVOICE</div>
            @if (ProformaInvoice) {
              <table class="potable">
                <tr>
                  <td><b> Invoice No</b></td>
                  <td>{{ ProformaInvoice.ProformaInvoiceNumber }}</td>
                </tr>
                <tr>
                  <td><b>Date</b></td>
                  <td>{{ ProformaInvoice.ProformaInvoiceDate | date: "dd-MMM-yyyy" }}</td>
                </tr>
                @if (ProformaInvoice.DeliveryTerm) {
                  <tr>
                    <td><b>Delivery Term</b></td>
                    <td>{{ ProformaInvoice.DeliveryTerm }}</td>
                  </tr>
                }
                <tr>
                  <td><b>Buyer Ref No.</b></td>
                  <td>{{ ProformaInvoice.BuyerReferenceNumber}}</td>
                </tr>
                <tr>
                  <td><b>{{ProformaInvoice.ReferenceType}}'s Ref</b></td>
                  <td>{{ ProformaInvoice.ConsignorReference }}</td>
                </tr>
                <tr>
                  <td><b>Bank Details :</b></td>
                  <td style="color: blue">
                    {{Bank?.BankName?.toString().toUpperCase()}}, {{Bank?.Branch?.toString().toUpperCase()}} BRANCH
                  </td>
                </tr>
                <td><b>Beneficiary Name:</b></td>
                <td style="color: blue">{{Bank?.AccountHolderName?.toString().toUpperCase()}}</td>
                <tr>
                  <td><b> ACCOUNT NUMBER:</b></td>
                  <td style="color: blue">{{Bank?.AccountNumber}}</td>
                </tr>
                <tr>
                  <td><b> IFSC CODE:</b></td>
                  <td style="color: blue">{{Bank?.Ifsc?.toString().toUpperCase()}}</td>
                </tr>
                <tr>
                  <td><b>MICR CODE:</b></td>
                  <td style="color: blue">{{Bank?.Micr?.toString().toUpperCase()}}</td>
                </tr>
                <tr>
                  <tr>
                    <td><b>SWIFT CODE:</b></td>
                    <td style="color: blue">{{Bank?.SwiftCode?.toString().toUpperCase()}}</td>
                  </tr>
                </table>
              }
            </div>
          </td>
        </tr>
      </table>
      <div class="producttable-container">
        <table class="producttable">
          <thead>
            <tr>
              <th width="50px">Sr.No</th>
              <th width="400px">Zaibunco Product Code/Description of Goods</th>
              <th width="150px">Article Name</th>
              <th>Quantity(MTR)</th>
              <th>PRICE({{ProformaInvoice.Currency}}/MTR)</th>
              <th>AMOUNT({{ProformaInvoice.Currency}})</th>
            </tr>
          </thead>
          <tbody>
            @for (data of ProformaInvoice.ProformaInvoiceItem; track data; let i = $index) {
              <tr>
                <td>{{ i + 1 }}</td>
                <td>{{data.SaleFormulationCodeProductName}} / {{ data.DescriptionOfGoods }}</td>
                <td>{{ data.ArticleName }}</td>
                <td>{{ data.Quantity }}</td>
                <td>{{ data.Price }}</td>
                <td>{{ (data.Price*data.Quantity).toFixed(2) }}</td>
              </tr>
            }
          </tbody>
          @if (this.ProformaInvoice.ProformaInvoiceItem.length>0) {
            <tfoot>
              <tr>
                <th></th>
                <th></th>
                <th>Total</th>
                <th>{{ CalculateGrandTotal(this.ProformaInvoice.ProformaInvoiceItem ,'Quantity') }}</th>
                <th></th>
                <th>{{ CalculateGrandTotal(this.ProformaInvoice.ProformaInvoiceItem ,'Total Price') }}</th>
              </tr>
            </tfoot>
          }
        </table>
        <table class="producttotaltable">
          <tbody>
            <tr>
              <td style="width: 60%">
                <b>Amount Chargeable</b>
                <div class="comments"></div>
              </td>
              <td>
                <b> (In words) ({{ProformaInvoice.Currency}})-{{TotalWord}} </b>
              </td>
              <td>
                <table class="producttotaltable" style="text-align: right">
                  <tbody>
                    <tr>
                      <td style="width: 75%"><b> Sub Total (A) </b></td>
                      <td style="width: 25%"> {{ CalculateGrandTotal(this.ProformaInvoice.ProformaInvoiceItem ,'Total
                      Price') | number:'1.2-2' }} </td>
                    </tr>
                    <tr>
                      <td style="width: 75%"><b> Add {{ProformaInvoice.Moq}}% Below MOQ Charge % (B) </b></td>
                      <td style="width: 25%"> {{ProformaInvoice.Moqtotal | number:'1.2-2'}} </td>
                    </tr>
                    <tr>
                      <td style="width: 75%"><b> After MOQ (C=A+B) </b></td>
                      <td style="width: 25%"> {{ (CalculateGrandTotal(this.ProformaInvoice.ProformaInvoiceItem ,'Total
                      Price') + ProformaInvoice.Moqtotal) | number:'1.2-2' }} </td>
                    </tr>
                    @if (ProformaInvoice.Gstn>'0') {
                      <tr>
                        <td style="width: 75%"><b> Total IGST/TAX ({{ProformaInvoice.Gstn}}%) (D) </b></td>
                        <td style="width: 25%"> {{ProformaInvoice.Gst | number:'1.2-2'}} </td>
                      </tr>
                    }
                    <tr>
                      <td style="width: 75%"><b>Discount {{ProformaInvoice.Discount}}% (E) </b></td>
                      <td style="width: 25%">-{{ calculateDiscountAmount() | number:'1.2-2' }}</td>
                    </tr>
                    <tr>
                      <td style="width: 75%"><b>Round-off (F) </b></td>
                      <td style="width: 25%">{{ProformaInvoice.RoundOff | number:'1.2-2'}}</td>
                    </tr>
                    <tr>
                      <td style="width: 75%"><b>Advance {{ ProformaInvoice.AdvancePercentage != null ?
                        ProformaInvoice.AdvancePercentage + '% ' : '' }}(G) </b></td>
                      <td style="width: 25%">-{{ (ProformaInvoice.AdvanceAmount || 0) | number:'1.2-2' }}</td>
                    </tr>
                    <!-- <tr>
                    <td style="width:50%"><b>Freight & Insurance </b></td>
                    <td style="width:50%"> 0.00</td>
                  </tr> -->
                  <!-- <tr>
                  <td style="width:50%"><b>Other </b></td>
                  <td style="width:50%"> 0.00</td>
                </tr> -->
              </tbody>
              <tfoot>
                <tr style="border-top: 2px solid">
                  <td style="width: 75%"><b>G.Total({{ProformaInvoice.Currency}}) (C+D-E+F-G) </b></td>
                  <td style="width: 25%">{{GTotal}}</td>
                </tr>
              </tfoot>
            </table>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  <div>
    <b>Terms & Conditions</b>
    <div [innerHTML]="ProformaInvoice.TermsCondition| nzSanitizer: 'html'"></div>
  </div>
  <!--<div class="footer" style="margin-bottom: 480px">
  <table class="footer-table">
    <tr>
      <td width="45%" style="vertical-align:text-top; padding-left: 20px; border-color: black; border-width: 2px;">
        <p style="margin-top: 5px"><b> Approved BY</b></p>
      </td>
      <td width="15%">
      </td>
      <td width="40%" style="text-align: left; padding-right: 20px;border-color: black; border-width: 2px;">
        <p style="margin-top: 10px">Signature</p>
        <p style="text-align: right;"><b>FOR ZAIBUNCO INDUSTRIES PVT LTD</b></p>
        <p style="font-size:10px;line-height:4;"><br /></p>
        <p style="margin-bottom: 2px;text-align: center;">AUTHORISED SIGNATORY</p>
      </td>
    </tr>
  </table>
</div>-->
<div class="footer" style="margin-bottom:480px;">
  <p>For any enquiry please contact </p>
  <table class="footer-table">
    <tr>
      <td width="33%" style="text-align: left; padding-left: 20px;">
        <p style="margin-bottom:50px"><b> PREPARED BY - </b></p>
        <p style="margin-top: -15px;">Auth Signatory</p>
      </td>
      <td width="34%">
        <p style="margin-bottom:50px"><b>APPROVED BY</b></p>
        <p style="margin-top: -15px;">Auth Signatory</p>
      </td>
      <td width="33%" style="text-align: right; padding-right: 20px;">
        <p style="margin-bottom:50px"><b>DIRECTOR'S SIGNATURE</b></p>
        <p style="margin-top: -15px;">Auth Signatory</p>
      </td>
    </tr>
  </table>
</div>
<app-print-footer [audience]="'external'"></app-print-footer>
</div>
}